import React, {Component} from "react";
import './baby-teething.css';
import * as teethActions from './TeethingActions';

export default function Jaw({TeethData, eleRef, section}) {
    // var TeethData = TeethEruptionData;
    console.log("section : ", section);
    return(
        <div>
            <div className="baby-jaw">
                <img src={require("../images/baby-teeth/jaw-bg.svg")}/>
                <span className="lower-jaw M15_white">Lower Jaw</span>
                <span className="upper-jaw M15_white">Upper Jaw</span>
                {TeethData && TeethData.map(babyteeth => 
                <div key={babyteeth.toothId} className={"baby-teeth teeth-" + babyteeth.toothId + babyteeth.toothNumber} id={babyteeth.toothId}>
                    <div className="pink-teeth" id={"pink_" + babyteeth.toothId} onClick={(e)=>eleRef.showDet(1, 'pink_'+babyteeth.toothId)}>
                        <span className="teethnum M13_white">{babyteeth.toothNumber}</span>
                        {
                            ((babyteeth.toothNumber == 9) || (babyteeth.toothNumber == 10)) ? 
                            <img src={require("../images/baby-teeth/pink-teeth-1.svg")}/> : ((babyteeth.toothNumber == 6) || (babyteeth.toothNumber == 5)) ? 
                            <img src={require("../images/baby-teeth/pink-teeth-2.svg")}/> : ((babyteeth.toothNumber == 8) || (babyteeth.toothNumber == 7)) ? 
                            <img src={require("../images/baby-teeth/pink-teeth-3.svg")}/> : ((babyteeth.toothNumber == 4) || (babyteeth.toothNumber == 3)) ? 
                            <img src={require("../images/baby-teeth/pink-teeth-4.svg")}/> : ((babyteeth.toothNumber == 1) || (babyteeth.toothNumber == 2)) ? 
                            <img src={require("../images/baby-teeth/pink-teeth-5.svg")}/> : null
                        }
                    </div>
                    <div className="white-teeth" id={"white_" + babyteeth.toothId} onClick={(e)=>eleRef.showDet(1, 'white_'+babyteeth.toothId)}>
                        <span className="teethnum M13_42">{babyteeth.toothNumber}</span>
                        {
                            ((babyteeth.toothNumber == 9) || (babyteeth.toothNumber == 10)) ? 
                            <img src={require("../images/baby-teeth/white-teeth-1.svg")}/> : ((babyteeth.toothNumber == 6) || (babyteeth.toothNumber == 5)) ? 
                            <img src={require("../images/baby-teeth/white-teeth-2.svg")}/> : ((babyteeth.toothNumber == 8) || (babyteeth.toothNumber == 7)) ? 
                            <img src={require("../images/baby-teeth/white-teeth-3.svg")}/> : ((babyteeth.toothNumber == 4) || (babyteeth.toothNumber == 3)) ? 
                            <img src={require("../images/baby-teeth/white-teeth-4.svg")}/> : ((babyteeth.toothNumber == 1) || (babyteeth.toothNumber == 2)) ? 
                            <img src={require("../images/baby-teeth/white-teeth-5.svg")}/> : null
                        }
                    </div>
                    { section == "eruption" ? 
                    <div className="outline-teeth">
                        <span className="teethnum M13_42">{babyteeth.toothNumber}</span>
                        {
                            ((babyteeth.toothNumber == 9) || (babyteeth.toothNumber == 10)) ? 
                            <img src={require("../images/baby-teeth/outline-teeth-1.svg")}/> : ((babyteeth.toothNumber == 6) || (babyteeth.toothNumber == 5)) ? 
                            <img src={require("../images/baby-teeth/outline-teeth-2.svg")}/> : ((babyteeth.toothNumber == 8) || (babyteeth.toothNumber == 7)) ? 
                            <img src={require("../images/baby-teeth/outline-teeth-3.svg")}/> : ((babyteeth.toothNumber == 4) || (babyteeth.toothNumber == 3)) ? 
                            <img src={require("../images/baby-teeth/outline-teeth-4.svg")}/> : ((babyteeth.toothNumber == 1) || (babyteeth.toothNumber == 2)) ? 
                            <img src={require("../images/baby-teeth/outline-teeth-5.svg")}/> : null
                        }
                    </div> : 
                    section == "shedding" ?
                    <div className="dead-teeth">
                        <span className="teethnum M13_white">{babyteeth.toothNumber}</span>
                        {
                            ((babyteeth.toothNumber == 9) || (babyteeth.toothNumber == 10)) ? 
                            <img src={require("../images/baby-teeth/dead-teeth-1.svg")}/> : ((babyteeth.toothNumber == 6) || (babyteeth.toothNumber == 5)) ? 
                            <img src={require("../images/baby-teeth/dead-teeth-2.svg")}/> : ((babyteeth.toothNumber == 8) || (babyteeth.toothNumber == 7)) ? 
                            <img src={require("../images/baby-teeth/dead-teeth-3.svg")}/> : ((babyteeth.toothNumber == 4) || (babyteeth.toothNumber == 3)) ? 
                            <img src={require("../images/baby-teeth/dead-teeth-4.svg")}/> : ((babyteeth.toothNumber == 1) || (babyteeth.toothNumber == 2)) ? 
                            <img src={require("../images/baby-teeth/dead-teeth-5.svg")}/> : null
                        }
                    </div> : null
                    }
                    <hr className={"myline info-line_" + babyteeth.toothId} />
                    { section == "eruption" ? 
                    <input type="hidden" value={babyteeth.startMonthEruption} className="erpstartmonth" /> :

                    section == "shedding" ?
                    <input type="hidden" value={babyteeth.startYearShedding} className="erpstartmonth" /> : null
                    }

                    { section == "eruption" ? 
                    <input type="hidden" value={babyteeth.endMonthEruption} className="erpendmonth" /> :

                    section == "shedding" ?
                    <input type="hidden" value={babyteeth.endYearShedding} className="erpendmonth" /> : null
                    }
                </div>
                )}
                <div className="tooth-info">
                    <div>{eleRef.state.toothName}</div>
                    <div>{eleRef.state.toothMonth}</div>
                </div>
            </div>
            <span className="R M15_75">R</span>
            <span className="L M15_75">L</span>
        </div>
    )
}



// WEBPACK FOOTER //
// src/shared/tools/baby-teething/Jaw.js